import { s } from "@kosmod/pancake";
import { define } from "./define";

export const managementLogic = {
  autoPopulateLogic: define('management:auto-populate', s.o({
    appearInDefaultMiniToolbar: s.bool,
  }))
}
